<div class="container py-5">
    <div class="row mb-4">
        <div class="col-12 mb-4 text-center">
            <p class="tab-ancla primary-500">FAQS</p>
            <h2 class="primary-900">¡Aclaramos tus dudas!</h2>
        </div>
        <div class="col-12 col-lg-10 gx-0 mx-auto">
            <app-bloque-faqs [faqs]="faqs"></app-bloque-faqs>
        </div>
    </div>

    <div class="text-center mt-3">
        <a [routerLink]="['/preguntas-frecuentes']" routerLinkActive="router-link-active" class="btn btn-primary"
            title="Ver todas las FAQs">
            Ver todas las FAQs
        </a>
    </div>
</div>